// This file has been refactored into modular components
// Import the new refactored SettingsPanel
import SettingsPanelNew from './SettingsPanelNew'

export default SettingsPanelNew